// Root CLAUDE.md: "Size rows, buttons, and skeleton heights against the
// AMHARIC rendering, never the English one." Ethiopic runs taller than
// Latin — the block heights below (56px title line, 44px body lines,
// matching this app's own 44px minimum tap-target floor from global.css)
// are sized generously enough to hold an Amharic line's full vertical
// reach, not trimmed to fit the shorter English string that might occupy
// the same slot.
//
// Only a "page" variant exists here (unlike admin's LoadingState, which
// also has a "rows" table-skeleton variant) — portal/ has no table anywhere
// in this task's scope; the only genuinely async load in this app's scope
// is AuthContext's initial GET /auth/me at boot.

import styles from './LoadingState.module.css';

export default function LoadingState() {
  return (
    <div className={styles.page} role="status" aria-live="polite">
      <div className={`${styles.block} ${styles.title} skeleton`} />
      <div className={`${styles.block} ${styles.line} skeleton`} />
      <div className={`${styles.block} ${styles.line} skeleton`} />
    </div>
  );
}
